import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import axios from "../../services/axios";
import { useCategories } from "../../hooks/database";
import NoChallengesModal from "../../components/modal/noChallenges";
import usePremiumTrial from "../../hooks/usePremiumTrial";
import useAuth from "../../hooks/useAuth";

import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setChallenge,
  setChallengeId,
  setPlayer1 as setP1,
  setPlayer2 as setP2,
} from "../../store/slices/translation";

import { FiAlertOctagon } from "react-icons/fi";

import Header, { BackHeaderLeft } from "../../components/navigation/header";
import DesafiosPlayerRoullete from "../../components/desafiosPicantes/playerRoulette";
import DesafiosCardGame from "../../components/desafiosPicantes/game";
import TranslationErrorModal from "../../components/desafiosPicantes/translationErrorModal";

function GoBack() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/hot-challenges");
  };
  return <BackHeaderLeft onClick={handleClick} />;
}

function HeaderRight() {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setVisible(true));
  };

  return (
    <button type="button" onClick={handleClick} className="touchable-opacity">
      <FiAlertOctagon size={28} />
    </button>
  );
}

const roulette_timings = {
  rotation_count: 3,
  rotation: 300,
  overshoot: 200,
  spring: 800,
  name_delay: 300,
  name: 500,
  selected: 1000,
  selected_delay: 900,
  fade: 600,
};

function getRouletteDuration() {
  return (
    roulette_timings.rotation * roulette_timings.rotation_count +
    roulette_timings.overshoot +
    roulette_timings.spring +
    roulette_timings.name_delay +
    roulette_timings.name +
    roulette_timings.selected +
    roulette_timings.selected_delay +
    roulette_timings.fade
  );
}

const ChallengesPerCategory = 12;
// 1 - homem 2 - mulher
export default function DesafiosGame() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { spendTrialCredit } = usePremiumTrial();
  const [categories] = useCategories();
  const { t, i18n } = useTranslation();
  const { selected } = useLocation().state;
  const { player1: p1, player2: p2 } = useSelector((state) => state.players);
  const { user } = useAuth();
  const firstRun = useRef(false);

  const [player1, setPlayer1] = useState({
    image: p1.avatar,
    name: p1.name || "",
    genre: p1.gender,
  });
  const [player2, setPlayer2] = useState({
    image: p2.avatar,
    name: p2.name || "",
    genre: p2.gender,
  });

  const [currentChallenge, setCurrentChallenge] = useState({});
  const [playedChallenges, setPlayedChallenges] = useState([]);
  const [challengeCategory, setChallengeCategory] = useState(0);
  const [challengeCount, setChallengeCount] = useState(0);
  const [endedModal, setEndedModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!Array.isArray(selected) || !selected.length) {
      navigate("/hot-challenges");
      return;
    }
  }, [selected]);

  useEffect(() => {
    if (!firstRun.current && categories.length) {
      firstRun.current = true;

      dispatch(setP1(player1?.name || ""));
      dispatch(setP2(player2?.name || ""));

      GetChallenge({
        player1: player1.genre,
        player2: player2.genre,
        canRemoveChallenge: false,
      });
    }
  }, [categories]);

  const GetChallenge = async ({
    player1,
    player2,
    canRemoveChallenge = true,
    overideCategory = null,
  }) => {
    try {
      setLoading(true);
      let allowed = false;

      if (user?.isPremium) {
        allowed = true;
      } else {
        // Checar se a categoria é premium
        if (categories.length) {
          const id_categoria = selected[challengeCategory];
          const category = categories.find((cat) =>
            cat?.custom
              ? cat.id_categoria === id_categoria
              : cat.id === id_categoria
          );

          if (category?.is_free) {
            allowed = true;
          } else {
            allowed = spendTrialCredit("desafios");
          }
        }
      }

      if (!allowed) {
        return null;
      }

      let i = 0 + challengeCategory;

      let exclude = [...playedChallenges];
      let category = selected[i];

      if (overideCategory) {
        category = overideCategory;
      }

      if (canRemoveChallenge) {
        if (currentChallenge?.desafio) {
          if (currentChallenge.custom) {
            exclude.push(`|${currentChallenge.id_desafio}|`);
          } else {
            exclude.push(currentChallenge.id);
          }
        }
      }

      const { data } = await axios.post("/challenge/getGameChallenge", {
        category: category,
        exclude: exclude,
        player1: player1,
        player2: player2,
        lang: i18n.language,
        id_usuario: user?.id_usuario,
      });
      let result = { ...data };

      if (!result?.id) {
        if (!result?.custom) {
          // Checar se tem mais categorias
          if (selected[i + 1]) {
            setLoading(false);
            setChallengeCategory((prev) => prev + 1);
            setChallengeCount(0);
            return;
          }
          setEndedModal(true);
          return false;
        }
      }

      setPlayedChallenges(exclude);

      setCurrentChallenge(result);
      dispatch(setChallenge(result?.desafio || ""));
      dispatch(setChallengeId(result?.id || 0));

      if (result.restantes === 1) {
        setChallengeCategory((prev) => prev + 1);
        setChallengeCount(0);
      }

      if (challengeCount + 1 > ChallengesPerCategory) {
        if (selected.length > challengeCategory + 1) {
          setChallengeCategory((prev) => prev + 1);
        }
        setChallengeCount(0);
      } else {
        setChallengeCount((prev) => prev + 1);
      }
      return result;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    const p1 = { ...player1 };
    const p2 = { ...player2 };

    GetChallenge({ player1: p2.genre, player2: p1.genre }).then((result) => {
      if (result) {
        // Switch players
        setPlayer1(p2);
        setPlayer2(p1);
        dispatch(setP1(p2?.name || ""));
        dispatch(setP2(p1?.name || ""));
      }
    });
  };

  const handleRestart = () => {
    navigate(0);
  };

  const handleCategories = () => {
    navigate("/hot-challenges");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header
        HeaderLeft={GoBack}
        HeaderCenter={() => null}
        HeaderRight={HeaderRight}
      />
      <DesafiosPlayerRoullete
        timings={roulette_timings}
        player1={player1}
        player2={player2}
      />
      <DesafiosCardGame
        roulette_duration={getRouletteDuration()}
        handleNext={handleNext}
        player1={player1}
        player2={player2}
        hotLevel={2}
        challenge={currentChallenge || {}}
        loading={loading}
      />
      <TranslationErrorModal />
      <NoChallengesModal
        title={t("noChallenges")}
        text1={t("dialogText1HotChallenges")}
        text2={t("dialogText2HotChallenges")}
        visible={endedModal}
        handleGoBack={handleCategories}
        handleRestart={handleRestart}
      />
    </div>
  );
}
